export default class NavActive {
  constructor () {
    this.menuWrapper = document.querySelector("[data-is-nav]")
    if (!this.menuWrapper) return

    this.menuLinks = this.menuWrapper.querySelectorAll("li")
    this.bindEvents()
  }

  bindEvents () {
    window.addEventListener("scroll", () => this.scrollLevel(), { passive: true })
  }

  scrollLevel () {
    const scrollPos = window.scrollY

    this.menuLinks.forEach((link) => {
      const href = link.querySelector('a[href^="#"]')?.getAttribute("href")
      if (!href || href === "#") return

      const refElement = document.querySelector(href)
      if (!refElement) return

      const top = refElement.getBoundingClientRect().top + window.scrollY
      const inView = (top - 175 <= scrollPos) && (top + refElement.offsetHeight > scrollPos)

      if (inView) {
        this.menuLinks.forEach((item) => item.classList.remove("active"))
        link.classList.add("active")
      } else {
        link.classList.remove("active")
      }
    })
  }
}
